import { httpClient } from '@/lib/http-client'

export const scoreLabelsApi = {
    getAll: () => httpClient.get('/score-labels'),
    create: (data: any) => httpClient.post('/score-labels', data),
    update: (value: number, data: any) =>
        httpClient.put(`/score-labels/${value}`, data),
    delete: (value: number) =>
        httpClient.delete(`/score-labels/${value}`),
    importData: (form: FormData) =>
        httpClient.post('/score-labels/import', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
    exportUrl: (format: string) => `/api/score-labels/export?format=${format}`,
}
